import styled from "styled-components";
import KeyboardSvg from "../../../assets/keyboard-icon.svg?react";

const rectanglesIds = [
	"r1",
	"r2",
	"r3",
	"r4",
	"r5",
	"r6",
	"r7",
	"r8",
	"r9",
	"r10",
	"r11",
	"r12",
	"r13",
	"r14",
	"r15",
] as const;
const backspaceId = "backspace";
const enterId = "enter";
const spaceId = "space";
const keyboardFrameId = "rect";

const StyledKeyboardSvg = styled(KeyboardSvg)`
    --size: 20dvh;
    --stroke-size: 1;
    --keyboard-rect-fill-color: var(--gray-11);
    --keyboard-rect-stroke-color: var(--gray-3);
    --backspace-fill-color: var(--gray-6); 
    --backspace-stroke-color: var(--gray-4);
    --enter-fill-color: var(--gray-6); 
    --enter-stroke-color: var(--gray-4);
    --space-fill-color: var(--gray-6); 
    --space-stroke-color: var(--gray-4);
    --key-passive-fill-color: var(--gray-6); 
    --key-passive-stroke-color: var(--gray-4); 
    --animation-duration: 750ms;
    height: var(--size);
    width: var(--size);
    border-radius: calc(var(--size) / 5);
    align-self: center;
    justify-self: center;

    @keyframes blink {
        33% {
            opacity: 1;
        }
        50% {
            opacity: 0.333;
        }
        66% {
            opacity: 1;
        }
    }
    #${keyboardFrameId} {
        stroke: var(--keyboard-rect-stroke-color);
        fill: var(--keyboard-rect-fill-color);
        box-shadow: 0 0 0 var(--stroke-size) var(--gray-3);
    }
    #${backspaceId} {
        fill: var(--backspace-fill-color);
        stroke-width: var(--stroke-size);
        stroke: var(--backspace-stroke-color);
    }
    #${spaceId} {
        fill: var(--space-fill-color);
        stroke-width: var(--stroke-size);
        stroke: var(--space-stroke-color);
    }
    #${enterId} {
        fill: var(--enter-fill-color);
        stroke-width: var(--stroke-size);
        stroke: var(--enter-stroke-color);
    }
	${rectanglesIds.map((id) => `#${id}`).join(",")} {
        fill: var(--key-passive-fill-color);
        stroke-width: var(--stroke-size);
        stroke: var(--key-passive-stroke-color);
		animation: blink var(--animation-duration) linear infinite forwards;
	}
    ${rectanglesIds
			.map((id, index) => {
				const cssId = `#${id}`;

				return `
                ${cssId} {
                    animation-delay: calc(var(--animation-duration) * ${(index * Math.random()).toFixed(6)});
                }`;
			})
			.join("")}
`;

const SVGWrapper = styled.div`
    position: relative;
    padding: var(--space-4);
`;

export function KeyboardLoader() {
	return (
		<SVGWrapper>
			<StyledKeyboardSvg />
		</SVGWrapper>
	);
}
